<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'" v-else>
    <a-row :gutter="8">
      <a-col :xs="{ span: 24 }">
        <a-card :loading="pageLoading" class="margin-bottom">
          <div slot="title">Traveloka Claim Manifest</div>

          <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>No Claim</span>
                  <span class="m-list-desc">{{ data.header.no_transaksi }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Created Date</span>
                  <span class="m-list-desc">{{ data.header.report_date }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User Creator</span>
                  <span class="m-list-desc">{{
                    data.header.tlc
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>User CC</span>
                  <span class="m-list-desc">{{
                    data.header.user_cc
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Total</span>
                  <span class="m-list-desc">{{
                    formatCurrency(data.header.currency, data.header.total)
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Note</span>
                  <span class="m-list-desc">{{ data.header.note ? data.header.note : '-' }}</span>
                </li>
              </ul>
            </div>
        </a-card>
        <a-collapse class="margin-top" activeKey="1">
          <a-collapse-panel key="1">
            <h4 slot="header" class="margin-remove">Usage Details</h4>
            <a-input-search
                v-model="search"
                placeholder="Quick Search"
                allowClear
                class="margin-bottom"
              />
              <a-table
                :columns="columns"
                :dataSource="searching"
                :pagination="pagination"
                :loading="loading.manifest"
                :rowKey="(record, index) => { return index; }" 
                size="small"
                bordered
                :scroll="{ x: 950 }"
              >
                <span slot="no" slot-scope="text, item, index">
                  {{ (pagination.page - 1) * pagination.pageSize + index + 1 }}
                </span>
                <span slot="tgl" slot-scope="item">
                  {{ moment(item.expense_date).format(getDefaultDateFormat) }}
                </span>
                <span slot="type" slot-scope="item">
                  {{ item.type_ticket }} / {{ item.user_booking }} / {{ item.no_booking }}
                </span>
                <span slot="val" slot-scope="item">
                  <CurrencyJustified
                    v-if="item.credit"
                    :currencyValue="data.header.currency"
                    :valueNumber="item.credit"
                  />
                  <div v-else style="text-align: center; width: 100%">-</div>
                </span>
                <span slot="budget" slot-scope="item">
                  <div v-if="item.no_sppd">SPPD : {{ item.no_sppd }}</div>
                  <div v-if="item.no_pp">PP : {{ item.no_pp }}</div>
                  <div v-if="!item.no_sppd && !item.no_pp && item.kode_anggaran">ANGGARAN : {{ item.kode_anggaran }}</div>
                  <div v-if="item.no_sppd || item.no_pp"><small><i>Anggaran : {{ item.kode_anggaran }}</i></small></div>
                  <div v-if="item.no_prospek"><small><i>Prospek : {{ item.no_prospek }} - {{ item.description_prospek }}</i></small></div>
                </span>
                <div slot="iscommision" slot-scope="item">
                  {{ item.iscommision=='1' ? 'Yes' : 'No' }}
                </div>
                <template slot="document" slot-scope="item">
                  <a v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)">
                    View Document
                  </a>
                  <span v-else>
                    No File Uploaded
                  </span>
                </template>

                <span slot="doc_tax" slot-scope="item">
                  <div style="text-align: center;">
                    <a-button icon="edit" size="small"
                      :type="item.tax_verif !== '0' ? 'primary' : 'danger'"
                      style="margin-right:5px" @click="handleShowTaxModal(item)"
                      :disabled="!(data.jenis !== 'Verifikator' || item.id_dtl == null && item.id_hdr == null)"
                      >
                    </a-button>
                  </div>
                </span>

                <div slot="footer" class="padding-all">
                  <a-row type="flex">
                    <a-col :span="12" :order="1" class="m-text-align left"
                      >Total Credit Ticket + Jasa + PPN - PPh </a-col
                    >
                    <a-col
                      :span="4"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                    <a-col
                      :span="8"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.header.currency"
                        :valueNumber="data.total_credit"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="12" :order="1" class="m-text-align left"
                      >Total Refund </a-col
                    >
                    <a-col
                      :span="4"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                    <a-col
                      :span="8"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.header.currency"
                        :valueNumber="data.total_refund"
                      />
                    </a-col>
                  </a-row>
                  <a-row type="flex">
                    <a-col :span="12" :order="1" class="m-text-align left"
                      ><b>Grand Total (Total Credit - Total Refund)</b></a-col
                    >
                    <a-col
                      :span="4"
                      :order="2"
                      class="m-text-align left m-text-bold"
                    ></a-col>
                    <a-col
                      :span="8"
                      :order="3"
                      class="m-text-align left m-text-bold"
                    >
                      <CurrencyJustified
                        :currencyValue="data.header.currency"
                        :valueNumber="data.grand_total"
                      />
                    </a-col>
                  </a-row>
                </div>
              </a-table>
          </a-collapse-panel>
        </a-collapse>
        <a-collapse class="margin-top" activeKey>
          <a-collapse-panel key="1">
            <div
              class="m-display-flex space-between align-middle"
              slot="header"
            >
              <h4 class="margin-remove">Status</h4>
              <div>
                <Status :status="data.last_status" />
              </div>
            </div>
            <a-timeline class="m-timeline">
              <a-timeline-item color="green">
                <div class="m-timeline-title">
                  Pembuat - {{ data.user_pembuat.tlc }}
                </div>
                <div class="m-timeline-body">
                  <h4 class="margin-remove">{{ data.user_pembuat.tanggal }}</h4>
                </div>
                <div class="m-timeline-footer">
                  <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                </div>
              </a-timeline-item>
              <a-timeline-item
                v-for="workflow in data.status"
                :key="workflow.step_no"
                :color="
                  workflow.status === 'On Process' ||
                  workflow.status === 'Delivered'
                    ? 'red'
                    : workflow.status === 'Waiting'
                    ? 'grey'
                    : 'green'
                "
              >
                <div class="m-timeline-title">
                  {{
                    workflow.actor === null ? workflow.jenis : workflow.actor
                  }}
                  {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                </div>
                <div class="m-timeline-body">
                  <h4
                    class="margin-remove"
                    v-if="workflow.tanggal_aksi !== null"
                  >
                    {{ workflow.tanggal_aksi }}
                  </h4>
                  <span
                    class="m-text-small"
                    v-if="workflow.remark == null || workflow.remark == ''"
                    >Tidak Ada Catatan</span
                  >
                  <span class="m-text-small" v-else>{{ workflow.remark }}</span>
                </div>
                <div class="m-timeline-footer">
                  <Status :status="workflow.status" />
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-collapse-panel>
        </a-collapse>
        

        <a-card
          class="margin-top"
          :loading="pageLoading"
          v-if="data.jenis.toLowerCase() === 'approve' || data.jenis.toLowerCase() === 'verifikator'"
        >
          <div slot="title">Manifest Actions</div>

          <a-form :form="form">
            <a-form-item label="Note">
              <a-textarea
                placeholder="Write the note here ... "
                :rows="2"
                v-decorator="['catatan']"
              />
            </a-form-item>
            <a-form-item label="Actions">
              <a-select
                showSearch
                v-decorator="['aksi', { rules: [{ required: true }] }]"
              >
                <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                  item.aksi
                }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Password">
              <a-input
                type="password"
                placeholder="Password"
                v-decorator="['password', { rules: [{ required: true }] }]"
              />
            </a-form-item>
            <a-form-item :wrapper-col="{ span: 24 }">
              <a-button
                @click="handleSubmit"
                block
                type="primary"
                html-type="submit"
                >Save</a-button
              >
            </a-form-item>
          </a-form>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from "axios";
import Status from "@/components/Status.vue";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";

export default {
  name: "manifestapproval",
  props: ["id"],
  components: { Status },
  mixins: [CurrencyFormat],
  data() {
    return {
      pageLoading: true,
      loading:{
        manifest: false
      },
      search: null,
      data: {
        header: []
      },
      submit: {},
      pagination: {
        onChange: (page) => { this.pagination.page = page},
        page: 1,
        pageSize: 5,
        size: "small",
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchManifest();
  },
  watch: {
    id() {
      if (this.id) {
        // this.fetchManifest();
      }
    },
  },
  computed: {
    ...mapGetters(["getScreen","getDefaultDateFormat"]),
    columns() {
      const kolom = [
        {
          title: "No",
          key: "no",
          width: 50,
          align: "right",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Date",
          width: 100,
          key: "tgl",
          align: "center",
          scopedSlots: { customRender: "tgl" },
          sorter: (a, b) =>
            new Date(
              moment(a.expense_date).format(
                this.getStandartFormatDate
              )
            ) -
            new Date(
              moment(b.expense_date).format(
                this.getStandartFormatDate
              )
            ),
        },
        {
          title: "Ticket Type / User Booking / No Booking ",
          scopedSlots: { customRender: "type" },
          width: 300,
          sorter: (a, b) => (a.type_ticket+a.user_booking+a.no_booking).localeCompare(b.type_ticket+b.user_booking+b.no_booking),
        },
        {
          title: "Value",
          key: "val",
          width: 180,
          sorter: (a, b) => a.credit - b.credit,
          scopedSlots: { customRender: "val" },
        },        
        {
          title: "Budget (No SPPD/PP/Cost Center)",
          key: "budget",
          width: 300,
          sorter: (a, b) => (a.no_sppd || a.no_pp || a.cost_center).localeCompare(b.no_sppd || b.no_pp || b.cost_center),
          scopedSlots: { customRender: "budget" },
        },
        {
          title: "Description",
          key: "desc",
          dataIndex: "description",
          width: 300,
        },
        {
          title: "IsCommision",
          key: "iscommision",
          width: 120,
          align: "center",
          sorter: (a, b) => (a.iscommision=='1' ? 'Yes' : 'No').localeCompare(b.iscommision=='1' ? 'Yes' : 'No'),
          scopedSlots: { customRender: "iscommision" },
        },
        {
          title: "Document",
          key: "document",
          scopedSlots: { customRender: "document" },
          width: 150,
          align: "center"
        },
      ];

      return kolom;
    },
    searching() {
      let data_ = [];
      if (this.search) {
        data_ = this.data.tableData.filter(
          (obj) =>
          (obj.expense_date && moment(obj.expense_date).format(this.getDefaultDateFormat).indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.type_ticket && obj.type_ticket.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.user_booking && obj.user_booking.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.no_booking && obj.no_booking.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.credit && this.formatRupiah(obj.credit).toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.no_sppd && obj.no_sppd.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.no_pp && obj.no_pp.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.cost_center && obj.cost_center.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) ||
          (obj.iscommision && (obj.iscommision=='1' ? 'yes' : 'no').indexOf(this.search.toLowerCase()) >= 0)
        );
      }else{
        data_ = this.data.tableData
      }

      return data_;
    },
  },
  methods: {
    moment,
    fetchManifest() {
      axios({
        method: "get",
        url: this.$serviceUrl + "public_manifest/manifest_klaim_traveloka",
        params: {
          id: this.id,
        },
      })
        .then((response) => {
          this.data = {
            header: response.data.invoice[0],
            tableData: response.data.dtl_invoice,
            actor: response.data.tlc,
            id: response.data.invoice[0].id_laporan,
            jenis: response.data.jenis,
            last_status: response.data.last_status,
            user_pembuat: {
              tlc: response.data.invoice[0].tlc,
              tanggal: response.data.invoice[0].report_date,
              status: "Created",
            },
            status: response.data.status_app,
            aksi: response.data.aksi,
            total_credit: response.data.total_credit,
            total_refund: response.data.total_refund,
            grand_total: response.data.grand_total
          };

          this.pageLoading = false;
        })
        .catch((err) => {
          if (err.response.status === 404) {
            this.displayMessage("404");
          }
          this.pageLoading = false;
        });
    },
    handlePrint() {},
    handleAction() {},
    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.pageLoading = false;
          this.displayMessage("choose-action");
          return;
        }

        let postData = new FormData();

        postData.append("id_laporan", this.data.id);
        postData.append("status", values.aksi);
        postData.append(
          "remark",
          values.catatan !== undefined ? values.catatan : ""
        );
        postData.append("tlc", this.data.actor);
        postData.append("password", values.password);

        axios({
          method: "post",
          url: this.$serviceUrl + "public_manifest/approval_klaim_traveloka",
          processData: false,
          data: postData,
        })
          .then((response) => {
            this.displayMessage("success");
            this.$router.go();
          })
          .catch((err) => {
            // console.log("error : " + err);
            if (err.response.data.status === false) {
              this.displayMessage("wrong-password");
            }
            this.pageLoading = false;
          });
      });
    },
  },
};
</script>

<style>
</style> 